<template>
  <v-container fluid>
    <v-row class="mx-auto">
      <v-col cols="12">
        <validation-provider v-slot="{ errors }" rules="required">
          <v-text-field id="titulo" v-model="titulo" class="my-0" label="Título" outlined :error-messages="errors" />
        </validation-provider>
      </v-col>
    </v-row>

    <v-row class="mx-auto">
      <v-col cols="12">
        <validation-provider v-slot="{ errors }" rules="required">
          <v-textarea
            id="obras"
            v-model="obras"
            class="mt-0 pt-0"
            label="Obras"
            placeholder="Insira os códigos das obras, um por linha. Ex.:

CI1944457111
CI1944457348"
            rows="5"
            no-resize
            clearable
            clear-icon="mdi-close-circle"
            :errors-messages="errors"
          />
        </validation-provider>
      </v-col>
    </v-row>

    <v-row align="center" no-gutters class="mx-4">
      <v-col cols="12">
        <validation-provider v-slot="{ errors }" rules="required">
          <v-select
            id="tipo-aderencia-bdgd"
            v-model="tipoBase"
            no-gutters
            outlined
            :items="tipoBaseList"
            label="Tipo de Base"
            :error-messages="errors"
          />
        </validation-provider>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import TesteQtdMatServService from '@/services/TesteQtdMatServService';

  export default {
    components: {},

    props: {},

    data() {
      return {
        titulo: null,
        obras: null,
        tipoBase: 'AMBOS',
        tipoBaseList: ['AMBOS', 'AIC', 'AIS']
      };
    },

    created() {
      if (this.$route.params.id) this.getById(this.$route.params.id);
    },

    methods: {
      getById(id) {
        TesteQtdMatServService.getById(id)
          .then((response) => {
            this.titulo = response.data.data.titulo;
            this.obras = response.data.data.obras;
            this.tipoBase = response.data.data.tipo_base;
          })
          .catch(() => {
            this.$toast.error('Erro ao recuperar o teste.', '', { position: 'topRight' });
          });
      },

      exportData() {
        return {
          id: this.$route.params.id ? this.$route.params.id : null,
          titulo: this.titulo,
          obras: this.obras,
          tipo_base: this.tipoBase
        };
      }
    }
  };
</script>
